import Scoring from './Scoring';

export default Scoring;
